import type { ReactNode } from 'react';
import './Toolbar.css';

/** DESIGN.md §9.2 `Toolbar`. A plain control row — height, padding, border and wrap behaviour
 * only. Callers own everything inside it, including which controls form a `Toolbar.Group`. */
export function Toolbar({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={['toolbar', className].filter(Boolean).join(' ')}>{children}</div>;
}

/** Pushes everything after it to the trailing edge of the toolbar. */
export function ToolbarSpacer() {
  return <div className="toolbar__spacer" />;
}

/** Groups related controls with the toolbar's standard inter-control gap (e.g. the density
 * switcher's three buttons), so ungrouped children keep the toolbar's larger gap between them. */
export function ToolbarGroup({ children }: { children: ReactNode }) {
  return <div className="toolbar__group">{children}</div>;
}
